import * as THREE from 'three';
import { markOverlay } from './edges';
import { hoverColor } from './palette';

const HIGHLIGHT_OPACITY = 0.4;

export function highlightMaterial(isDark: boolean): THREE.MeshBasicMaterial {
  return new THREE.MeshBasicMaterial({
    color: hoverColor(isDark),
    transparent: true,
    opacity: HIGHLIGHT_OPACITY,
    depthWrite: false,
    polygonOffset: true,
    polygonOffsetFactor: -2,
    polygonOffsetUnits: -2,
    side: THREE.DoubleSide,
    toneMapped: false,
  });
}

export function addHighlight(mesh: THREE.Mesh, material: THREE.Material): THREE.Mesh {
  const overlay = markOverlay(new THREE.Mesh(mesh.geometry, material));
  mesh.add(overlay);
  return overlay;
}
